var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessageError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  strokeWidth: 0,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C4.136 1 1 4.136 1 8s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7m1 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0m0-3a1 1 0 0 1-2 0V5a1 1 0 0 1 2 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7 5v3a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0m2 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
})));
export default SvgMessageError;